import { LogoDisplay } from '@web/components/atoms/Logo'
import { FontObject, FONTS } from './fonts'

type LogoSelection = {
  [key in LogoDisplay]: string
}

interface FontSelection {
  [key: string]: FontObject
}

interface ColorSelection {
  [key: string]: string
}

enum ButtonColorProperty {
  bgColor = 'bgColor',
  hoverBgColor = 'hoverBgColor',
  textColor = 'textColor',
  hoverTextColor = 'hoverTextColor',
  outlineColor = 'outlineColor',
  hoverOutlineColor = 'hoverOutlineColor',
}

export type ButtonVariant = 'solid' | 'outline'

type ButtonColors = {
  variant: ButtonVariant
  bgColor: string
  outlineColor?: string
  hoverBgColor: string
  hoverOutlineColor?: string
  textColor?: string
  hoverTextColor?: string
}

interface ButtonColorSelection {
  [key: string]: ButtonColors
}

interface ButtonStyleSelection {
  font: FontObject
  cornerRadius: number | ''
  buttonColors: ButtonColorSelection
}

const DEFAULT_FONT = FONTS[0]
const DEFAULT_FONT_DATA: FontSelection = {
  heading1: { ...DEFAULT_FONT, fontSize: '32px' },
  heading2: { ...DEFAULT_FONT, fontSize: '24px' },
  normal: { ...DEFAULT_FONT, fontSize: '16px' },
}
const DEFAULT_COLOR_DATA: ColorSelection = {
  Background: '#fff',
  Brand: '#29AAE2',
  'Text dark': '#000',
  'Text light': '#fff',
}
const DEFAULT_BUTTON_DATA: ButtonStyleSelection = {
  font: DEFAULT_FONT,
  cornerRadius: 4,
  buttonColors: {
    Primary: { variant: 'solid', bgColor: DEFAULT_COLOR_DATA.Brand, hoverBgColor: '#01567B' },
    Secondary: { variant: 'outline', bgColor: DEFAULT_COLOR_DATA.Brand, hoverBgColor: '#01567B' },
  },
}

export {
  type FontSelection,
  type ColorSelection,
  type ButtonStyleSelection,
  type ButtonColors,
  type LogoSelection,
  ButtonColorProperty,
  DEFAULT_FONT,
  DEFAULT_FONT_DATA,
  DEFAULT_COLOR_DATA,
  DEFAULT_BUTTON_DATA,
}
